<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'

export default {

	page: {
		title: 'Новый пользователь',
		meta: [{ name: 'description', content: appConfig.description }],
	},

	components: { Layout, PageHeader, Multiselect },

	data() {
        return {
			title: 'Новый пользователь',
			items: [],
            isAdmin: false,
            isCompany: false,
            user_uuid: '',
            profile_uuid: '',
            account_uuid: '',
            create_account: false,
            show_create_account: false,
            phone: '',
            email: '',
            name1: '',
            name2: '',
            name3: '',
            password: '',
            company: null,
            company_options: [],
            trackBy: 'id',
            initRole: [],
            role: null,
            roles_options: [
                {id: 'administrator', name: 'Администратор'},
                {id: 'member',     name: 'Пользователь'},
            ],
            initType: [],
            type: null,
            types_options: [
                {id: 'administrator', name: 'Администратор'},
                {id: 'manager',    name: 'Менеджер'},
                {id: 'consultant', name: 'Консультант'},
                {id: 'client',     name: 'Клиент'},
                {id: 'partner',    name: 'Партнер'},
                {id: 'dev',        name: 'Разработчик'},
            ],
            initStatus: [],
            status: null,
            status_options: [
                {id: 'active', name: 'Активен'},
                {id: 'wait', name: 'Ожидает активации'},
                {id: 'blocked', name: 'Заблокирован'},
            ]
		}
	},

    watch: {
        initStatus: {
            immediate: true,
            handler(values) {
                this.status = this.status_options.filter(x => values.includes(x[this.trackBy]));
                this.status = this.status[0];
            }
        },
        initType: {
            immediate: true,
            handler(values) {
                this.type = this.types_options.filter(x => values.includes(x[this.trackBy]));
                this.type = this.type[0];
            }
        },
        initRole: {
            immediate: true,
            handler(values) {
                this.role = this.roles_options.filter(x => values.includes(x[this.trackBy]));
                this.role = this.role[0];
            }
        },
    },

	computed: {
        user_item(){
            let user = this.$store.getters['users/GET_USERS_ITEM'];
            return user;
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            let user = session.user ? session.user : null;
            return user;
        },
        company_list_data(){
            return this.$store.getters['companies/GET_COMPANIES_LIST_DATA'];
        },
	},

	async mounted() {

        if(this.session_user_item && this.session_user_item.role == 'administrator'){
            this.isAdmin = true;
        }
        if(this.session_user_item && this.session_user_item.iscompany){
            if(this.session_user_item.iscompany == 'false') {
                this.isCompany = false;
            }
            if(this.session_user_item.iscompany == 'true') {
                this.isCompany = true;
            }
        }

        let company_data_send = {
        };
        await this.$store.dispatch('companies/FETCH_COMPANIES_LIST', company_data_send);
        this.company_options = this.company_list_data;

        this.user_uuid = this.$route.params.user_uuid ? this.$route.params.user_uuid : '';

        if(this.user_uuid !== ''){

            this.title = 'Редактирование пользователя';
            document.title = appConfig.title + ' - ' + 'Редактирование пользователя';

            let data_send = {
                'uuid' : this.user_uuid,
            }

            await this.$store.dispatch('users/FETCH_USERS_ITEM', data_send);

            let user = this.user_item;

            this.profile_uuid = user.profile && user.profile.uuid ? user.profile.uuid : '';
            this.account_uuid = user.account && user.account.uuid ? user.account.uuid : '';

            this.phone = user.phone ? user.phone : '';
            this.email = user.email ? user.email : '';
            this.name1 = user.profile && user.profile.name1 ? user.profile.name1 : '';
            this.name2 = user.profile && user.profile.name2 ? user.profile.name2 : '';
            this.name3 = user.profile && user.profile.name3 ? user.profile.name3 : '';
            this.company_id = user.account && user.account.company_id ? user.account.company_id : '';

            this.role  = user.role ? user.role : '';
            this.initRole = [this.role];

            this.type  = user.type ? user.type : '';
            this.initType = [this.type];

            this.status = user.status ? user.status : '';
            this.initStatus = [this.status];

        } else {
            this.show_create_account = true;
        }
	},

	methods: {

        async saveUser(){

            let data_send = {};

            let result = '';

            if(this.user_uuid === ''){

                let data_send = {
                    'uuid'     : this.user_uuid,
                    'email'    : this.email,
                    'phone'    : this.phone,
                    'name1'    : this.name1,
                    'name2'    : this.name2,
                    'name3'    : this.name3,
                    'password' : this.password,
                    'status'   : this.status && this.status.id ? this.status.id : null,
                    'company_id'   : this.company && this.company.id ? this.company.id : null,
                    'company_name' : this.company && this.company.name ? this.company.name : null,
                };

                if(this.isAdmin){
                    data_send.role = this.role && this.role.id ? this.role.id : null;
                    data_send.type = this.type && this.type.id ? this.type.id : null;
                }

                result = await this.$store.dispatch('users/FETCH_USERS_CREATE', data_send);
            } else {

                let data_send_user = {
                    'uuid'     : this.user_uuid,
                    'email'    : this.email,
                    'phone'    : this.phone,
                    'role'     : this.role && this.role.id ? this.role.id : null,
                    'type'     : this.type && this.type.id ? this.type.id : null,
                    'status'   : this.status && this.status.id ? this.status.id : null,
                    'password' : this.password
                };
                let user_update_result = await this.$store.dispatch('users/FETCH_USERS_UPDATE', data_send_user);

                let data_send_profile = {
                    'uuid'  : this.profile_uuid,
                    'name1' : this.name1,
                    'name2' : this.name2,
                    'name3' : this.name3,
                };
                let profile_update_result = await this.$store.dispatch('profiles/FETCH_PROFILES_UPDATE', data_send_profile);

                if (user_update_result === false || profile_update_result === false){
                    result = false;
                }

            }

            if(result === false){
                alert('Возникла ошибка');
            } else {
                this.$router.push({ name: 'Users'});
            }
        }
	}

}
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
        <b-form
            class="form-horizontal"
            @submit.prevent="saveUser"
        >
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                            <div class="row">
                                <div class="col">

                                    <b-form-group
                                        label="Номер телефона"
                                        label-for="phone"
                                    >
                                        <b-form-input
                                            id="phone"
                                            v-model="phone"
                                            placeholder="Номер телефона пользователя"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="E-mail адрес"
                                        label-for="email"
                                    >
                                        <b-form-input
                                            id="email"
                                            v-model="email"
                                            placeholder="E-mail адрес, если есть"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Пароль"
                                        label-for="password"
                                    >
                                        <b-form-input
                                            id="password"
                                            v-model="password"
                                            placeholder="Новый пароль"
                                        ></b-form-input>
                                    </b-form-group>

                                    <br>

                                    <b-form-group
                                        label="Фамилия"
                                        label-for="name3"
                                    >
                                        <b-form-input
                                            id="name3"
                                            v-model="name3"
                                            placeholder=""
                                        ></b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                        label="Имя"
                                        label-for="name1"
                                    >
                                        <b-form-input
                                            id="name1"
                                            v-model="name1"
                                            placeholder=""
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Отчество"
                                        label-for="name2"
                                    >
                                        <b-form-input
                                            id="name2"
                                            v-model="name2"
                                            placeholder=""
                                        ></b-form-input>
                                    </b-form-group>

                                    <br>
                                    <b-form-group
                                        v-show="isAdmin"
                                        label="Роль пользователя"
                                        label-for="role"
                                    >
                                        <multiselect
                                            id="role"
                                            :track-by="trackBy"
                                            v-model="role"
                                            :options="roles_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                        ></multiselect>
                                    </b-form-group>

                                    <b-form-group
                                        label="Тип пользователя"
                                        label-for="type"
                                    >
                                        <multiselect
                                            id="type"
                                            v-show="isAdmin"
                                            :track-by="trackBy"
                                            v-model="type"
                                            :options="types_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                        ></multiselect>
                                    </b-form-group>

                                    <b-form-group
                                        v-show="isAdmin"
                                        label="Статус"
                                        label-for="status"
                                    >
                                        <multiselect
                                            id="status"
                                            :track-by="trackBy"
                                            v-model="status"
                                            :options="status_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                        ></multiselect>
                                    </b-form-group>

                                    <b-form-group
                                    >
                                        <div class="form-group mb-4" v-show="show_create_account">
                                            <div class="custom-control custom-checkbox">
                                                <input
                                                    id="checkbox-signin"
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    v-model="create_account"
                                                />
                                                <label
                                                    class="custom-control-label"
                                                    for="checkbox-signin"
                                                >
                                                    Создать аккаунт для пользователя
                                                </label>
                                            </div>
                                        </div>
                                    </b-form-group>

                                    <b-form-group
                                        v-show="create_account"
                                        label="Компания"
                                        label-for="phone"
                                    >
                                        <multiselect
                                            id="phone"
                                            v-model="company"
                                            :options="company_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                            track-by="id"
                                        ></multiselect>
                                    </b-form-group>
                                </div>
                            </div>
                    </div>
                    <hr style="margin-bottom: 0px !important; margin-top: 0px !important">
                    <div style="padding: 0.75rem">
                        <button type="submit" class="btn btn-primary">Сохранить</button>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card-->
            </div>
            <!-- end col -->
        </div>
        </b-form>
	</Layout>
</template>
